import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs';
import { InvitesService } from './invites.service';

export class InvitesDataSource extends DataSource<any> {
  constructor(private invitesService: InvitesService, private schoolId: string | null) {
    super();
  }

  connect(): Observable<any[]> {
    return this.invitesService.getInvites(this.schoolId);
  }

  override disconnect(): void {
    // throw new Error('Method not implemented.');
  }
}
